import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Support.css";
import { HiChevronDown } from "react-icons/hi2";
import { FiMail, FiMapPin, FiPhone, FiSend, FiFileText } from "react-icons/fi";
import { useParkSettings } from "../../../utils/parkSettings";

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? "open" : ""}`}>
      <button
        className="faq-question"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span>{question}</span>
        <HiChevronDown className="faq-icon" size={18} />
      </button>
      <div className="faq-answer">
        <div className="faq-answer-inner">{answer}</div>
      </div>
    </div>
  );
}

// Opening hours come from the park settings (/park in the admin console).
const DAY_KEYS = { 1: 'dayMon', 2: 'dayTue', 3: 'dayWed', 4: 'dayThu', 5: 'dayFri', 6: 'daySat', 0: 'daySun' };

export default function Support() {
  const today = new Date().getDay();
  const navigate = useNavigate();
  const { t } = useTranslation('support');
  const { pointsPercent, hours: parkHours } = useParkSettings();
  const faqs = t('faqs', { returnObjects: true, percent: pointsPercent });

  return (
    <div className="support-wrapper">
      <div className="hero-card">
        <h2>{t('heroTitle')}</h2>
        <p>{t('heroDesc')}</p>
      </div>

      <div className="section-label">{t('sectionLocation')}</div>

      <div className="location-card">
        <div className="location-header">
          <div className="location-icon"><FiMapPin /></div>
          <div>
            <h3>{t('cityName')}</h3>
            <p>{t('cityRegion')}</p>
          </div>
        </div>

        <div className="location-divider" />

        <div className="location-rows">
          <div className="location-row">
            <FiMail />
            <span>{t('emailLabel')}</span>
            <a href="mailto:post@playworld.no">post@playworld.no</a>
          </div>
          <div className="location-row">
            <FiPhone />
            <span>{t('phoneLabel')}</span>
            <a href="tel:94467290">944 67 290</a>
          </div>
        </div>

        <div className="location-divider" />

        <div className="hours-grid">
          {parkHours.map((h) => (
            <div key={h.day} className={`hours-row${h.day === today ? ' today' : ''}`}>
              <span>{t(DAY_KEYS[h.day])}</span>
              <strong>{h.closed ? [t('closed'), h.reason].filter(Boolean).join(' – ') : `${h.open} - ${h.close}`}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="section-label">{t('sectionFaq')}</div>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>

      <div className="section-label">{t('sectionMoreHelp')}</div>

      <div className="contact-card">
        <h3>{t('contactTitle')}</h3>
        <p>{t('contactDesc')}</p>
        <a className="contact-btn" href="mailto:post@playworld.no">
          <FiSend />
          {t('sendEmail')}
        </a>
      </div>

      <div className="section-label">{t('sectionTerms')}</div>

      <div className="contact-card">
        <h3>{t('termsTitle')}</h3>
        <p>{t('termsDesc')}</p>
        <button type="button" className="contact-btn" onClick={() => navigate('/personvern')}>
          <FiFileText />
          {t('viewTermsPayment')}
        </button>
      </div>
    </div>
  );
}